import WebmasterCandidate from './WebmasterCandidate'
import { Component } from 'preact'

class EmailManager extends Component {
  constructor (props) {
    super()
    this.state = { emails: props.emails ? props.emails : [] }
  }

  deleteEmail (email) {
    this.setState({ emails: this.state.emails.filter(e => e !== email) })
  }

  render (props, state) {
    return state.emails.length > 0 || props.type === 'verification'
      ? <div class={'emails-' + props.type}>
        <h3>{props.title}</h3>
        <div class='alert'>{props.tip}</div>
        { state.emails.length > 0
          ? state.emails.map(e => <WebmasterCandidate email={e} showSendButton={props.type !== 'success'} showDeleteButton onDelete={() => this.deleteEmail(e)} />)
          : <WebmasterCandidate email='' showSendButton /> }
      </div>
      : null
  }
}

export default EmailManager
